import Header from "./Header";
import Taisao from "./Taisao";
import Tantam from "./Tantam";
import Quytrinh from "./Quytrinh";
import Danhgia from "./Danhgia";
import Contact from "./Contact";
import Ads from "./Ads";

export default function Homerut() {
  return (
    <div>
      <Header />
      <Taisao />
      <Tantam />
      <Quytrinh />
      <Danhgia />
      <Ads />
      <Contact />
    </div>
  );
}
